import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "foquz-icon-client-last-order",
  "use": "foquz-icon-client-last-order-usage",
  "viewBox": "0 0 15 15",
  "content": "<symbol viewBox=\"0 0 15 15\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"foquz-icon-client-last-order\"><path d=\"M11 1v2.167M4 1v2.167M1 6h13m-1.444-4H2.444C1.646 2 1 2.71 1 3.485v9.113C1 13.373 1.646 14 2.444 14h10.112c.798 0 1.444-.627 1.444-1.402V3.485C14 2.711 13.354 2 12.556 2z\" stroke=\"#73808D\" stroke-width=\"2\" stroke-miterlimit=\"10\" stroke-linecap=\"round\" stroke-linejoin=\"round\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol